import { render, staticRenderFns } from "./multimenu.vue?vue&type=template&id=1d5954fc&scoped=true&"
import script from "./multimenu.vue?vue&type=script&lang=js&"
export * from "./multimenu.vue?vue&type=script&lang=js&"
import style0 from "./multimenu.vue?vue&type=style&index=0&id=1d5954fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5954fc",
  null
  
)

export default component.exports